import React from 'react';
import './LinkElement.css';

export default class LinkElement extends React.Component{
	
	static defaultProps = {
		href: '#',
		label: 'label',
		target: '',
		className: '',
	};
	
	render = () => {
		return (
			<div className={`${this.props.className} rcg-link-container`}>
				<a href={this.props.href} target={this.props.target} className="btn" title={this.props.label}>
					<span className="text-outline text-center">{this.props.label}</span>
					<span className="btn_bg"/>
				</a>
			</div>
		);
	};
}


// WEBPACK FOOTER //
// ./src/components/LinkElement.js